/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Legal_Save_SuccessInputs */

const en_admin_legal_save_success = /** @type {(inputs: Admin_Legal_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved successfully.`)
};

const de_admin_legal_save_success = /** @type {(inputs: Admin_Legal_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfolgreich gespeichert.`)
};

/**
* | output |
* | --- |
* | "Saved successfully." |
*
* @param {Admin_Legal_Save_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_legal_save_success = /** @type {((inputs?: Admin_Legal_Save_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Legal_Save_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_legal_save_success(inputs)
	return en_admin_legal_save_success(inputs)
});